import React, { useEffect } from 'react'
import { storeAssigned } from '../../services/Methods/normalMethods'

const ScrollToTopOnPathChange = ({ location }) => {
    useEffect(() => {
        if (location !== `/${storeAssigned()}`) {
            window.scrollTo({ top: 0, behavior: 'smooth' })
        }
    }, [location])

    return (
        <></>
    )
}
export default ScrollToTopOnPathChange